import { Link } from "react-router-dom";

import { routes } from "@/common/utils/routes";
import UsersIcon from "@/common/images/icons/users.svg?react";
import { nFormatter } from "@/common/utils/parseNumber";
import { INiche } from "@/common/services/types";

import "./NichePreviewInfo.scss";

interface IProps {
  niche: INiche;
  onPreviewClick?: () => void;
}

export const NichePreviewInfo = ({ niche, onPreviewClick }: IProps) => {
  return (
    <div className="NichePreviewInfo">
      <Link to={routes.niche(niche.id)} onClick={onPreviewClick}>{niche.name}</Link>

      <div className="NichePreviewSubscribes">
        <UsersIcon />
        <span>{nFormatter(niche.subscribers)}</span>
      </div>
    </div>
  );
};
